export default {
	TYPES: [
		[0, 'No Dashboard'],
		[1, 'Sales'],
		[3, 'Production'],
		[4, 'Batching'],
		[5, 'Engineering']
	]
}